<template>
  <div>

    <a :href="'https://www.youtube.com/watch?v=' + video.id" class="video" v-for="video in videos[genre]" :key="video.id">
      <div class="thumbnail">
        <img :src="video.thumbnailUrl">
        <div class="duration">{{ video.duration }}</div>
      </div>
      <div class="text">
        <div class="title">{{ video.title }}</div>
        <div class="channelTitle">{{ video.channelTitle }}</div>
        <div class="count-and-date">???万 回視聴・{{ video.createDate | simpleDate }}</div>
        <div class="description">{{ video.description }}</div>
        <div class="mobile-channelIcon"><i class="fas fa-user-circle fa-2x face"></i></div>
        <div class="mobile-threePoint"><i class="fas fa-ellipsis-v fa-lg"></i></div>
      </div>
    </a>

    <div class="loader-frame">
      <div class="loader" v-if="videosLoading"></div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/firestore';
export default {
  name: 'List',
  props:{
    genre : String,
    videos : Object
  },
  data () {
    return {
      videosLoading : false,
      endCreateDate : "2100-12-31",
      noMore : false
    }
  },
  methods:{

    //--------------
    // db取得処理
    //--------------
    getVideos(){

      // もうない
      if(this.noMore) return;

      // ロード中は無視
      if(this.videosLoading) return;

      // ロード開始
      this.videosLoading = true;

      // リファレンス
      const db = firebase.firestore();
      let videosRef = db.collection("videos").orderBy("createDate", "desc").limit(this.$moreAmount).startAfter(this.endCreateDate);

      // ジャンル指定時
      if(this.genre != "nothing"){
        videosRef = videosRef.where("genre", "==", this.genre);
      }

      // 取得
      videosRef.get().then(querySnapshot => {
        querySnapshot.forEach(doc => {
          const data = doc.data();
          data.id = doc.id;
          this.videos[this.genre].push(data);
        });

        // 読み込み位置を更新
        if(this.videos[this.genre].length > 0){
          this.endCreateDate = this.videos[this.genre].slice(-1)[0].createDate;
        }

        // 全部読み込んだ
        if(querySnapshot.docs.length == 0 || this.videos[this.genre].length >= this.$maxAmount[this.genre]){
          this.noMore = true;
        }

        // ロード終了
        this.videosLoading = false;

      // 異常時
      }).catch(error => {

        // ロード終了
        this.videosLoading = false;
        console.log(error);
      });
    },

    //------------------
    // スクロールロード
    //------------------
    onScroll:function(){

      // もうない
      if(this.noMore) return;

      // ロード中は無視
      if(this.videosLoading) return;

      // maxまで読み込んだら無視
      if(this.videos.length >= 6) return;

      // 画面端までいったら
      if ((window.innerHeight + window.pageYOffset) >= document.body.offsetHeight - 10) {
        this.getVideos();
      }
    }
  },

  //-------------
  // マウント時
  //-------------
  mounted(){

    // 初めて表示した時
    if(!this.videos[this.genre]){
      this.videos[this.genre] = [];
      this.getVideos();

    // 2回目以降の場合
    }else{

      // 一番下の登録日を更新（startAfterで使う）
      this.endCreateDate = this.videos[this.genre].slice(-1)[0].createDate;
    }

    // スクロールイベント登録
    window.addEventListener("scroll", this.onScroll);
  },

  //------------
  // 後片付け
  //------------
  destroyed(){

    // スクロールイベント削除
    window.removeEventListener("scroll", this.onScroll);
  }


}
</script>



// WEBPACK FOOTER //
// src/components/List.vue